import clsx from "clsx";
import React from "react";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import LazyModal from "web/react/components/lazy-modal/lazy-modal";
import styles from "./generic-modal.module.css";

interface GenericModalProps {
    children: JSX.Element;
    isOpen: boolean;
    onAfterOpen?: () => void;
    onClose: () => void;
    className?: string;
    overlayClassName?: string;
    closeClassName?: string;
    fullscreen?: boolean;
    closable?: boolean;
    noScroll?: boolean;
}

function GenericModal({
    children,
    isOpen,
    onAfterOpen,
    onClose,
    className,
    overlayClassName,
    closeClassName,
    fullscreen = false,
    closable = true,
    noScroll,
}: GenericModalProps): null | JSX.Element {
    let appElement: HTMLElement | undefined;
    if (document.body) {
        appElement = document.body.querySelector<HTMLDivElement>(".site-wrapper") || undefined;
    }

    return (
        <LazyModal
            appElement={appElement}
            className={clsx(styles.modal, className, {
                [styles.fullscreen]: fullscreen,
            })}
            noScroll={noScroll}
            isOpen={isOpen}
            onAfterOpen={(): void => {
                onAfterOpen && onAfterOpen();
            }}
            onRequestClose={onClose}
            overlayClassName={clsx(styles.overlay, overlayClassName)}
            shouldCloseOnOverlayClick={closable}
            shouldCloseOnEsc={closable}
        >
            {closable && (
                <div className={clsx(styles.closeContainer, closeClassName)}>
                    <CloseButton onClick={onClose} />
                </div>
            )}
            {children}
        </LazyModal>
    );
}

export default GenericModal;
